<template>
  <v-row no-gutters>
  <template v-if="loading">
    <v-row no-gutters class="px-5">
      <v-col cols="12">
        <v-skeleton-loader
          type="image"
          width="100%"
          height="40px"
          class="my-4"
        />
      </v-col>
    </v-row>
  </template>
    <v-col  v-else cols="12" sm="12">
      <v-container class="px-0" fluid :key="render">
        <v-row align="center" class="switch-row" v-for="(item, index) in defaultFoldawayItems" :key="index">
          <v-col class="label-col">
            <span class="meeting-label">{{ item.label }}</span>
          </v-col>
          <v-col cols="auto" class="switch-col">
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                  <span 
                    v-bind="attrs"
                    v-on="on"
                    >{{ $t('admin.lblCollapse') }}</span>
              </template>
              <span>{{ $t('admin.lblKeepFoldawayCollapsed') }}</span>
            </v-tooltip>
            <v-switch
            v-model="isMeetingDescriptionCollapsed"
            @change="handleSwitchChange"
            color="primary"
            ></v-switch>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                  <span 
                    v-bind="attrs"
                    v-on="on"
                    >{{ $t('admin.lblExpand') }}</span>
              </template>
              <span>{{ $t('admin.lblKeepFoldawayExpanded') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import tenantConfigService from "../../api/tenantConfigService";
import { createUUID } from "../../utils/util";

export default {
  name: "DefaultFolding",
  data() {
    return {
      render: 0,
      isMeetingDescriptionCollapsed: false,
      displayMessage: false,
      messageType: "",
      message: "",
      tenantId: localStorage.getItem("tenantId") || "",
      currentConfig: null,
      loading: true,
    };
  },
  async created() {
    try {
      const configList = await tenantConfigService.getTenantConfigList();
      const defaultFoldingConfig = configList.find(config => config.configname === "defaultFolding");

      if (defaultFoldingConfig && Array.isArray(defaultFoldingConfig.defaultFolding)) {
        const meetingDescConfig = defaultFoldingConfig.defaultFolding.find(item => item.item === "Meeting Description");
        if (meetingDescConfig) {
          this.isMeetingDescriptionCollapsed = meetingDescConfig.folded;
        }
        this.currentConfig = { ...defaultFoldingConfig };
      } else {
        // No config exists, set default value to false
        this.isMeetingDescriptionCollapsed = false;
        this.currentConfig = null;
      }
    } catch (error) {
      console.error('Error loading default folding config:', error);
      // Set defaults on error
      this.isMeetingDescriptionCollapsed = false;
      this.currentConfig = null;
    } finally {
      this.loading = false;
      this.render++;
    }
  },
  computed: {
    ...mapGetters({
      tenantSettingTypes: "tenant/tenantSettingTypes",
    }),
    defaultFoldawayItems() {
      return [
        {
          label: this.$t('admin.lblMeetingDescription'),
        },
      ];
    },
    switchLabel() {
      return this.isMeetingDescriptionCollapsed ? 
        this.$t('Collapse') : 
        this.$t('Expand');
    },
  },
  methods: {
    ...mapActions({
      getTenantConfigList: "tenant/getTenantConfigList",
      createTenantConfig: "tenant/createTenantConfig",
      updateTenantConfig: "tenant/updateTenantConfig",
    }),
    async handleSwitchChange(value) {
      try {
        if (this.currentConfig) {
          const updatedConfig = { ...this.currentConfig };
          const itemToUpdate = updatedConfig.defaultFolding.find(item => item.item === "Meeting Description");
          if (itemToUpdate) {
            itemToUpdate.folded = value;
          }
          await this.updateTenantConfig(updatedConfig);
        } else {
          const configId = createUUID()
          const newConfig = {
            id: configId,
            tenantId: this.tenantId,
            configname: "defaultFolding",
            defaultFolding: [
              {
                item: "Meeting Description",
                folded: value
              }
            ]
          };
          await this.createTenantConfig(newConfig);
          
          const configList = await tenantConfigService.getTenantConfigList();
          const defaultFoldingConfig = configList.find(config => config.configname === "defaultFolding");
          
          if (defaultFoldingConfig && Array.isArray(defaultFoldingConfig.defaultFolding)) {
            const meetingDescConfig = defaultFoldingConfig.defaultFolding.find(item => item.item === "Meeting Description");
            if (meetingDescConfig) {
              this.isMeetingDescriptionCollapsed = meetingDescConfig.folded;
            }
            this.currentConfig = { ...defaultFoldingConfig };
          }
          this.render++;
        }
        
        this.$eventHub.$emit("onMessageDisplay", {
          message: this.$t("admin.msgDefaultFoldawayUpdation"),
          messageType: "success",
        });
      } catch (error) {
        console.error('Error updating default folding config:', error);
        this.isMeetingDescriptionCollapsed = !value;
      }
    },
  },
};
</script>

<style scoped>
.switch-row {
  padding: 10px 50px;
  width: inherit;
}

.switch-col {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 20px;
}

.label-col {
  flex: 1;
  padding-left: 16px;
}

.meeting-label {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

:deep(.v-input--selection-controls__input) {
  margin-right: 8px;
}

:deep(.v-label) {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>